import Navigation from './components/navigation/navigation.component';
import Footer from './sections/footer/footer.section.jsx';
import CardItems from './components/cards/cards.component';
import './App.css';
import {Routes, Route} from 'react-router-dom';
import Home from './pages/home/home';
import SignUpForm from './components/sign-up/sign-up.component';
import SignInForm from './components/sign-in/sign-in.component';
import Findtruck from './pages/findtruck/findtruck.pages.jsx';
import FindMdse from './pages/find-mdse/find-mdse.page.jsx';
import Addtruck from './pages/addtruck/addtruck.page.jsx';
import AddMdse from './pages/add-mdse/add-mdse.page.jsx';
import Pricing from './pages/pricing/pricing.page.jsx';
import Ourservices from './pages/ourservices/ourservices.pages.jsx';
import ScrollToTop from './components/scroll-to-top/scroll-to-top.component.jsx'
import PrivacyPolicy from './pages/privacy-policy/privacy-policy.page.jsx'
import CookiesPolicy from './pages/cookies-policy/cookies-policy.page.jsx'

const SITE_ENABLED = false;

const App = () => {
if (!SITE_ENABLED) {
    return null; // renders a blank page
  }



  return(

    <>
    <ScrollToTop />
    <Routes>
      <Route path='/' element={
          <>
          <Navigation />
          <Footer />
          </>
        }
      
      >
        <Route index element={<Home />}/>
        <Route index element={<CardItems />}/>
        <Route path='/sign-up' element={<SignUpForm />}/>
        <Route path='/sign-in' element={<SignInForm />}/>
        <Route path='/findtruck' element={<Findtruck />}/>
        <Route path='/findMdse' element={<FindMdse />}/>
        <Route path='/addtruck' element={<Addtruck />}/>
        <Route path='/addmdse' element={<AddMdse />}/>
        <Route path='/pricing' element={<Pricing />}/>
        <Route path='/ourservices' element={<Ourservices />}/>
        <Route path='/privacypolicy' element={<PrivacyPolicy />}/>
        <Route path='/cookiespolicy' element={<CookiesPolicy />}/>
      </Route>
    </Routes>
    </>
  );
}

export default App;